import { useState, useCallback } from "react";
import { stravaService } from "../services/StravaService";

export function useStravaActivities() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importing, setImporting] = useState(false);
  const [error, setError] = useState(null);

  const fetchActivities = useCallback(async (limit = 15) => {
    try {
      setLoading(true);
      setError(null);
      const data = await stravaService.getActivities(limit);
      const items = Array.isArray(data) ? data : data.atividades || [];
      setActivities(items);
      return items;
    } catch (err) {
      console.error("Erro ao buscar atividades do Strava:", err);
      setError(err.message || "Erro ao carregar atividades");
      setActivities([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const importActivity = useCallback(async (payload) => {
    try {
      setImporting(true);
      setError(null);
      const result = await stravaService.importarMetrica(payload);
      return result;
    } catch (err) {
      console.error("Erro ao importar atividade do Strava:", err);
      setError(err.message || "Erro ao importar atividade");
      throw err;
    } finally {
      setImporting(false);
    }
  }, []);

  return {
    activities,
    loading,
    importing,
    error,
    fetchActivities,
    importActivity,
  };
}

export default useStravaActivities;
